import { Flex, HStack, Skeleton, SkeletonText, Stack } from '@chakra-ui/react';

export const SchedulePayoutSectionSkeleton: React.FC = () => {
  return (
    <Stack gap={4} mt={6}>
      {/* Skeleton for Title */}
      <SkeletonText noOfLines={1} width="300px" h="24px" mb={3} />

      {/* Skeleton for Radio Cards */}
      <HStack gap={4} align="stretch">
        {/* Skeleton for "As soon as possible" card */}
        <Flex
          flex={1}
          border="1px solid"
          borderColor="gray.200"
          rounded="xl"
          p={4}
          align="start"
          direction="column"
          gap={2}
        >
          <HStack justify="space-between" w="full">
            <SkeletonText noOfLines={1} width="150px" h="20px" />
            <Skeleton h="20px" w="20px" rounded="full" />
          </HStack>
          <SkeletonText noOfLines={1} width="80%" h="16px" />
        </Flex>

        {/* Skeleton for "Schedule date" card */}
        <Flex
          flex={1}
          border="1px solid"
          borderColor="gray.200"
          rounded="xl"
          p={4}
          align="start"
          direction="column"
          gap={2}
        >
          <HStack justify="space-between" w="full">
            <SkeletonText noOfLines={1} width="120px" h="20px" />
            <Skeleton h="20px" w="20px" rounded="full" />
          </HStack>
          <SkeletonText noOfLines={1} width="90%" h="16px" />
        </Flex>
      </HStack>

      {/* Skeleton for Alert */}
      <Flex
        bg="gray.50" // Mimic alert background
        rounded="xl"
        p={4}
        mt={4}
        align="start"
        gap={3}
      >
        <Skeleton h="20px" w="20px" mt={1} /> {/* Icon skeleton */}
        <Stack flex={1} gap={2}>
          <SkeletonText noOfLines={1} width="70%" h="18px" /> {/* Title skeleton */}
          <SkeletonText noOfLines={2} width="95%" h="14px" /> {/* Description skeleton */}
        </Stack>
      </Flex>
    </Stack>
  );
};

export default SchedulePayoutSectionSkeleton;
